import Text from 'components/Text/Text';
import React, { useContext, useState, useEffect } from 'react';
import { IStyleContext, StyleContext } from './styleState/styleContext';
import Sidebar from './components/Sidebar/Sidebar';
import LanguageBar from './components/LanguageBar/LanguageBar';
import UseCustomerSettingsCheckBox from './components/UseCustomerSettingsCheckBox/UseCustomerSettingsCheckBox';
import StyleFields from 'components/StyleFields/StyleFields';
import MediaFields from './components/MediaFields/MediaFields';
import DocumentSettings from './components/DocumentSettings/DocumentSettings';
import AdditionalSettings from './components/AdditionalSettings/AdditionalSettings';
import BtnBlock from './components/BtnBlock/BtnBlock';
import NoData from 'components/NoResultsFound/NoData';
import ModalWindows from './components/ModalWindows/ModalWindows';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import classNames from 'classnames';
import style from './StyleForm.module.scss';

interface IStyleForm {
	isVisible: boolean;
}

const StyleForm: React.FC<IStyleForm> = ({ isVisible }) => {
	const {
		setStyleSettings,
		mediaSettingsForUpdate,
		documentSettingsForUpdate,
		selectedGroup,
		styleSettingColors,
		useCustomerSettings,
		loading,
	} = useContext<IStyleContext>(StyleContext);
	const [isFirstEntry, setIsFirstEntry] = useState(true);
	const hasAdditionalSettingsAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.RESTAURANT_MANAGER,
		UserRoles.TECHNICAL,
	]);
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	useEffect(() => {
		if (isFirstEntry && isVisible && loading) {
			setIsFirstEntry(false);
		}
	}, [isVisible, loading]);

	return (
		<div className={containerClasses} data-test="StyleForm">
			{mediaSettingsForUpdate.length ? (
				<>
					<div className={style.sidebar}>
						<Sidebar />
					</div>
					<div className={style.content}>
						<LanguageBar />
						<div className={style.fieldsWrapper}>
							<Text
								translationNameSpace="mediaSettings"
								translationKey="customerSettingsLabel"
								theme="secondary"
								size="l"
								weight="bold"
							/>
							<UseCustomerSettingsCheckBox />
						</div>
						<div className={style.inputsWrapper}>
							<StyleFields
								selectedGroup={selectedGroup}
								setStyleSettings={setStyleSettings}
								styleSettingColors={styleSettingColors}
								useCustomerSettings={useCustomerSettings}
							/>
						</div>
						<div className={style.inputsWrapper}>
							{mediaSettingsForUpdate.map((el) => (
								<MediaFields data={el} key={el.languageId} />
							))}
						</div>
						{documentSettingsForUpdate.map((el) => (
							<div className={style.fieldsWrapper} key={el.key}>
								<DocumentSettings data={el} />
							</div>
						))}
						{hasAdditionalSettingsAccess && (
							<div className={style.fieldsWrapper}>
								<Text
									translationNameSpace="mediaSettings"
									translationKey="additional_setting_file"
									theme="secondary"
									size="l"
									weight="bold"
								/>
								<AdditionalSettings />
							</div>
						)}
						<BtnBlock />
					</div>
				</>
			) : (
				<>{!loading && !isFirstEntry ? <NoData /> : null}</>
			)}
			<ModalWindows />
		</div>
	);
};

export default StyleForm;
